<template>
  <div class="w-full h-full overflow-hidden">
    <div id="previewpage" class="flex w-full h-full">
        <div class=""></div>
        <div id="page-profil" class="h-full w-full flex-shrink-0  relative transition-next le">
            <div v-if="user && (user.description == ''|| user.description == null)" class="h-full w-full backdrop-blur-md absolute flex items-center z-30">
                <div class="lg:w-[70%] w-[90%]  h-[70%] mx-auto bg-white border-[1px] border-gray-300 rounded-md">
                    <div class="w-full h-[10%] xl:h-[20%] flex items-center">
                        <div class="w-[95%] h-[90%]  mx-auto flex overflow-hidden">
                            <div class="h-full w-1/3 flex items-center  border-b-[1px] justify-end">
                                <div class="w-[98%] h-full flex items-center relative">
                                    <div :class="etape >= 2 ? 'border-[#FF9900] border-t-[1px] border-b-[1px] border-l-[1px]':'border-gray-400 border-t-[1px] border-b-[1px] border-l-[1px]'" class="flex items-center h-full w-[87%] space-x-2 px-2">
                                        <div class="w-8 h-8 rounded-full border-2 border-[#FF9900] flex items-center mx-auto md:mx-0">
                                            <p  class="mx-auto text-[#FF9900]">1</p>
                                        </div>
                                        <p class="text-[#FF9900] hidden md:block text-[0.7rem] lg:text-md xl:text-base">{{ $t('informtionsupplementaire') }}</p>  
                                    </div>
                                    <img v-if="etape < 2" class="h-[6rem] 2xl:h-[10rem] 2xl:right-[0.9rem] w-[13%] absolute right-[0.4rem] md:right-3" src="/icons/expand_arrow_500px.png" alt="" srcset="">
                                    <img v-if="etape >= 2" class="h-[6rem] 2xl:h-[10rem] 2xl:right-[0.9rem] w-[13%] absolute right-[0.4rem] md:right-3" src="/icons/expand_arrow_500_orange.png" alt="" srcset="">
                                </div>
                            </div>
                            <div class="h-full w-1/3 flex items-center justify-end">
                                <div class="w-[98%] h-full flex items-center relative">
                                    <div :class="etape >= 3 ? 'border-[#FF9900] border-t-[1px] border-b-[1px] border-l-[1px]':'border-gray-400 border-t-[1px] border-b-[1px] border-l-[1px]'" class="flex items-center h-full w-[87%] space-x-2 px-2">
                                        <div :class="etape >= 2 ? 'border-[#FF9900]':'border-gray-400'" class="w-8 h-8 rounded-full border-2 mx-auto md:mx-0 flex items-center">
                                            <p :class="etape >= 2 ? 'text-[#FF9900]':'text-gray-400'" class="mx-auto">2</p>
                                        </div>
                                        <p :class="etape >= 2 ? 'text-[#FF9900]':'text-gray-400'" class="hidden md:block text-[0.7rem] lg:text-md xl:text-base">{{ $t('photodeprofil') }}</p>  
                                    </div>
                                    <img v-if="etape < 3" class="h-[6rem] w-[13%] 2xl:h-[10rem] 2xl:right-[0.9rem] absolute right-[0.4rem] md:right-3" src="/icons/expand_arrow_500px.png" alt="" srcset="">
                                    <img v-if="etape >= 3" class="h-[6rem] w-[13%] 2xl:h-[10rem] 2xl:right-[0.9rem] absolute right-[0.4rem] md:right-3" src="/icons/expand_arrow_500_orange.png" alt="" srcset="">
                                </div>
                            </div>
                            <div class="h-full w-1/3 flex items-center justify-end">
                                <div class="w-[98%] h-full flex items-center relative">
                                    <div :class="etape >= 4 ? 'border-[#FF9900] border-t-[1px] border-b-[1px] border-l-[1px]':'border-gray-400 border-t-[1px] border-b-[1px] border-l-[1px]'" class="flex items-center h-full w-[87%] space-x-2 px-2">
                                        <div :class="etape >= 3 ? 'border-[#FF9900]':'border-gray-400'" class="w-8 h-8 rounded-full border-2 mx-auto md:mx-0 flex items-center">
                                            <p :class="etape >= 3 ? 'text-[#FF9900]':'text-gray-400'" class="mx-auto">3</p>
                                        </div>
                                        <p :class="etape >= 3 ? 'text-[#FF9900]':'text-gray-400'" class="hidden md:block text-[0.7rem] lg:text-md xl:text-base">{{ $t('finalisationencour') }}</p>  
                                    </div>
                                    <img v-if="etape < 4" class="h-[6rem] w-[13%] 2xl:h-[10rem] 2xl:right-[0.9rem] absolute right-[0.4rem] md:right-3" src="/icons/expand_arrow_500px.png" alt="" srcset="">
                                    <img v-if="etape >= 4" class="h-[6rem] w-[13%] 2xl:h-[10rem] 2xl:right-[0.9rem] absolute right-[0.4rem] md:right-3" src="/icons/expand_arrow_500_orange.png" alt="" srcset="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="w-full h-[90%] xl:h-[80%]">
                        <div class="h-[80%] overflow-y-auto">
                            <!--Etape 1-->
                            <div class="w-full h-full flex py-3" v-if="etape == 1">
                                <div class="mx-auto  flex-wrap justify-center space-y-3">
                                    <div>
                                        <label for="" class="text-gray-400">{{ $t('sexe') }}</label><br>
                                        <select v-model="form.sexe" name="" id="" class="rounded-lg  bg-gray-200 h-12 w-72 md:w-[25rem] px-5 outline-none">
                                            <option value="Homme">{{ $t('homme') }}</option>
                                            <option value="Femme">{{ $t('femme') }}</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label for="" class="text-gray-400">{{ $t('paysorigine') }}</label><br>
                                        <select v-model="form.mon_pays" name="" id="" class="rounded-lg  bg-gray-200 h-12 w-72 md:w-[25rem] px-5 outline-none">
                                            <option value="Cameroun">Cameroun</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label for="" class="text-gray-400">{{ $t('ville') }}</label><br>
                                        <div  class="rounded-lg  bg-gray-200 h-12 w-72 md:w-[25rem] px-5 outline-none flex items-center">
                                            <p>{{ $t('detectionposition') }} {{ user.ville }}</p>
                                        </div>
                                    </div>
                                    <div>
                                        <label for="" class="text-gray-400">{{ $t('quartier') }}</label><br>
                                        <input v-model="form.quartier" name=""  id="" class="rounded-lg  bg-gray-200 h-12 w-72 md:w-[25rem] px-5 py-2 outline-none" >
                                    </div>
                                    <div>
                                        <label for="" class="text-gray-400">{{ $t('datedenaissance') }}</label><br> 
                                        <VueDatePicker v-model="form.date_naissance" class="rounded-lg w-full  outline-none" text-input selectOnFocus @update:model-value="handleDateUpdate"  :start-date="form.date_naissance" :max-date="MaxYear(new Date())" format="yyyy-MM-dd" auto-apply :enable-time-picker="false" vertical :clearable="false" :month-change-on-scroll="false" no-swipe :locale="langue"  :style="'height:'+ height"/>
                                    </div>
                                    <div>
                                        <div class="w-full flex justify-between">
                                            <label for="" class="text-gray-400">{{ $t('descriptiondevotreboutique') }}</label>
                                            <p class="text-gray-400">{{ form.description.trim().length }}</p>
                                        </div>
                                        <textarea v-model="form.description" name=""  id="" class="rounded-lg  bg-gray-200 h-24 w-72 md:w-[25rem] md:h-[10rem] px-5 py-2 outline-none" ></textarea>
                                    </div>
                                </div>
                            </div>
                            <!--Etape 2-->
                            <div v-if="etape == 2" class="flex items-center w-full h-full">
                                <div :class="form.avatar ? 'bg-transparent':'bg-black'" class="md:h-44 md:w-44 h-36 w-36 mx-auto rounded-full flex items-center relative">
                                    <div class="w-6 h-6 bg-[#FF9900] absolute md:right-2 right-0 top-2 rounded-full flex items-center overflow-hidden">
                                        <input @change="addAvatar" type="file" name="avatar" accept="image/*" id="avatar" class="hidden">
                                        <label for="avatar" class="w-full h-full flex items-center cursor-pointer">
                                            <img class="w-3 h-3 mx-auto" src="/icons/icons8_edit_1@2x.png" alt="" srcset="">
                                        </label>
                                    </div>
                                    <img v-if="avatarSelect" class="w-full h-full object-cover object-center rounded-full " :src="avatarSelect" alt="" srcset="">
                                    <img v-if="avatarSelect == ''" class="w-20 h-20 mx-auto object-cover object-center rounded-full " src="/logo/mel_logo_noir.png" alt="" srcset="">
                                </div> 
                            </div>

                            <!--Etape 3-->
                            <div v-if="etape == 3" class=" flex items-center w-full h-full">
                                <div v-if="saveLoading == 'oui'" class="w-44 h-44 mx-auto rounded-full flex items-center bg-green-500">
                                    <img class="w-20 h-20 mx-auto" src="/icons/checkmark_512px.png" alt="" srcset="">
                                </div>
                                <div v-if="saveLoading == 'non'" class="
                                    rounded-lg
                                    flex
                                    items-center
                                    justify-center
                                    text-white
                                    w-44
                                    mx-auto
                                    h-full
                                    text-center">
                                    <svg aria-hidden="true" class="inline w-44 h-44 mr-2 text-gray-200 animate-spin dark:text-white fill-[#FF9900]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="h-[20%] relative flex items-center">
                            <div class="absolute right-1 space-x-2">
                                <button v-if="etape > 1 && etape < 3" @click="preview" class="px-2 py-2 bg-[#FF9900] text-white hover:border-2 hover:border-[#FF9900] hover:bg-transparent hover:text-[#FF9900] rounded-md">{{ $t('retour') }}</button>
                                <button @click="next" v-if="etape < 2" class="px-2 py-2 bg-[#FF9900] text-white hover:border-2 hover:border-[#FF9900] hover:bg-transparent hover:text-[#FF9900] rounded-md">{{ $t('suivant') }}</button>
                                <button @click="saveInformation" v-if="etape == 2" class="px-2 py-2 bg-[#FF9900] text-white hover:border-2 hover:border-[#FF9900] hover:bg-transparent hover:text-[#FF9900] rounded-md">{{ $t('finaliser') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="user" class="h-full w-full relative">
                <div class="h-[10%] bg-[#F8F8F8] w-full flex items-center">
                    <div class="w-full justify-between md:px-3 flex mt-1">
                        <div class="flex justify-between items-center md:justify-normal w-full md:w-auto">
                            <div class="flex space-x-2 px-2 md:px-4  md:border-r-[1px] border-gray-300">
                                <div class=" rounded-full w-10 h-10 overflow-hidden bg-white flex items-center justify-center">
                                    <img v-if="user.avatar" class="w-full h-full object-cover object-center " :src="user.avatar" alt="" srcset="">
                                    <img v-if="user.avatar == '' || user.avatar == null" class="w-7 h-7 mx-auto object-cover object-center  " src="/logo/mel_logo_noir.png" alt="" srcset="">
                                </div>
                                <div class="h-auto">
                                    <div class="h-auto">
                                        <p class=" font-semibold">{{ user.name }}</p>
                                    </div>
                                    <div class="flex space-x-1">
                                        <div>
                                          <svg :class="Math.round(user.etoile/user.avis) >= 1 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                                            <g id="surface1">
                                            <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                                            </g>
                                          </svg>
                                        </div>
                                        <div>
                                          <svg :class="Math.round(user.etoile/user.avis) >= 2 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                                            <g id="surface1">
                                            <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                                            </g>
                                          </svg>
                                        </div>
                                        <div>
                                          <svg :class="Math.round(user.etoile/user.avis) >= 3 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                                            <g id="surface1">
                                            <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                                            </g>
                                          </svg>
                                        </div>
                                        <div>
                                          <svg :class="Math.round(user.etoile/user.avis) >= 4 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                                            <g id="surface1">
                                            <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                                            </g>
                                          </svg>
                                        </div>
                                        <div>
                                          <svg :class="Math.round(user.etoile/user.avis) >= 5 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                                            <g id="surface1">
                                            <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                                            </g>
                                          </svg>
                                        </div> 
                                    </div>
                                </div>
                                <div class="h-auto flex items-center">
                                    <img v-if="user.type != 0" class="w-5 h-5 mx-auto object-cover object-center rounded-full " src="/icons/approval2.png" alt="" srcset="">
                                </div>
                            </div>
                            <div class="flex space-x-6 h-auto items-center px-2 md:px-4">
                                <div class="md:flex hidden">
                                    <img class="md:w-6 md:h-6 h-4 hidden md:block" src="/icons/icons8_slide_up@2x.png" alt="" srcset="">
                                    <img class="md:w-6 md:h-6 h-4 md:hidden" src="/icons/chevronuporange.png" alt="" srcset="">
                                    <p class="text-xs md:text-base ml-1">{{ user.nbr_suiveur < 10 && (user.nbr_suiveur >0) ? '0'+user.nbr_suiveur : user.nbr_suiveur }} {{ $t('abonnes') }}</p>
                                </div>
                            </div>
                            <button :disabled="user.status == 'block'? true:false" @click="openAddProduct" :class="user.status == 'block' ? 'opacity-70':'opacity-100'" class=" flex-1 md:px-2 h-min py-1 mx-auto bg-[#FF9900] text-white rounded-full flex items-center overflow-hidden">
                                <div class="w-full h-full flex items-center">
                                  <div class="flex mx-auto space-x-1 text-sm">
                                    <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" version="1.1">
                                        <g id="surface1">
                                        <path style=" stroke:none;fill-rule:nonzero;fill:#FFFFFF;fill-opacity:1;" d="M 240 64 L 240 144 L 272 144 L 272 99 C 352.625 107.3125 416 173.125 416 256 C 416 344.5625 344.5625 416 256 416 C 167.4375 416 96 344.5625 96 256 C 96 204.5625 119.9375 158.8125 157.5 129.5 L 138 104.5 C 92.9375 139.625 64 194.5 64 256 C 64 361.875 150.125 448 256 448 C 361.875 448 448 361.875 448 256 C 448 150.125 361.875 64 256 64 Z M 171.5 148.5 L 148.5 171.5 L 244.5 267.5 C 247.375 270.375 251.5625 272 256 272 C 264.8125 272 272 264.8125 272 256 C 272 251.5625 270.375 247.375 267.5 244.5 Z "/>
                                        </g>
                                    </svg>
                                    <div class="h-auto flex items-center">
                                        <p>{{ $t('debuterunevente') }}</p>
                                    </div>
                                  </div>
                                </div>
                            </button>
                        </div>
                        <div class="md:flex items-center hidden space-x-2">
                            <div class=" flex space-x-2">
                                <div class="h-auto flex items-center">
                                    <p class="text-xs md:text-base ">{{ $t('niveau') }} {{user.niveau}}<span class="ml-2">{{ user.point }} pts/100</span></p>
                                </div>
                                <div>
                                    <CircleProgressBar class="w-9 h-9" :colorUnfilled="'#FF9900'" :strokeWidth="'10px'" :animationDuration="'3s'"  :value="user.point" :max="100">{{user.niveau}}</CircleProgressBar>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="h-[90%] w-full flex">
                    <div class="h-full xl:w-[18%] bg-[#FF9900]  relative link">
                        <div class="w-full absolute bottom-0 px-2 xl:px-0 flex space-x-2">
                            <div class="w-[90%] mx-auto flex">
                                <img class="h-8 md:h-9" src="/logo/logo mel completement blanc.png" alt="" srcset="">
                                <div class="h-auto flex items-center">
                                    <p class="text-white hidden xl:block text-[0.7rem] mt-2">{{  $t('membredepuis') }} {{ JSON.parse($t('mois'))[new Date(user.created_at).getMonth()] }} {{ new Date(user.created_at).getFullYear() }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="w-full cursor-pointer xl:h-[12%] h-[8%] flex">
                            <router-link to="/infoprofil" class=" w-full h-full flex xl:block px-3 mx-auto">
                                <div class=" h-full flex items-center mx-auto  space-x-4">
                                    <img class="md:h-8  h-6 object-contain" src="/icons/icons8_male_user@2x.png" alt="" srcset="">
                                    <p class="text-white hidden xl:block text-lg">{{ $t('moncompte') }}</p>
                                </div>
                            </router-link>
                        </div>
                        <div class="w-full cursor-pointer xl:h-[12%] h-[8%] mt-2 md:mt-0 flex">
                            <router-link to="mes-abonnees" class="w-full flex xl:block px-3 h-full mx-auto">
                                <div class="h-full flex items-center mx-auto space-x-4">
                                    <img class="md:h-8 h-6 object-contain" src="/icons/subscribers.png" alt="" srcset="">
                                    <p class="text-white hidden xl:block text-lg">{{ $t('mesabonnees') }}</p>
                                </div>
                            </router-link>
                        </div>
                        <div class="w-full cursor-pointer xl:h-[12%] h-[8%] mt-2 md:mt-0 flex">
                            <router-link to="mon-porte-feuille" class="w-full flex xl:block px-3 h-full mx-auto">
                                <div class=" h-full flex mx-auto items-center space-x-4">
                                    <img class="md:h-8 h-6 object-contain" src="/icons/wallet.png" alt="" srcset="">
                                    <p class="text-white hidden xl:block text-lg">{{ $t('portefeuille') }}</p>
                                </div>
                            </router-link>
                        </div>
                        <div class="w-full cursor-pointer xl:h-[12%] h-[8%] mt-2 md:mt-0 flex">
                            <router-link to="mes-commandes" class="w-full flex xl:block px-3 h-full mx-auto">
                                <div class=" h-full flex mx-auto items-center space-x-4">
                                    <img class="md:h-7 h-5 object-contain" src="/icons/icons8_shopping_basket@2x.png" alt="" srcset="">
                                    <p class="text-white hidden xl:block text-lg">{{ $t('mescommandes') }}</p>
                                </div>
                            </router-link>
                        </div>
                        <div class="w-full cursor-pointer xl:h-[12%] h-[8%] mt-2 md:mt-0 flex">
                            <router-link to="/mes-articles" class="w-full flex xl:block px-3 h-full mx-auto">
                                <div class="h-full flex items-center mx-auto space-x-4">
                                    <img class="md:h-8 h-6 object-contain" src="/icons/icons8_sell@2x.png" alt="" srcset="">
                                    <p class="text-white hidden xl:block xl:text-lg">{{ $t('mesarticles') }}</p>
                                </div>
                            </router-link>
                        </div>
                        <div class="w-full my-auto cursor-pointer xl:h-[12%] h-[8%] mt-2 md:mt-0 flex">
                            <router-link to="mes-statistiques" class="w-full flex xl:block px-3 h-full mx-auto">
                                <div class="h-full flex items-center mx-auto space-x-4">
                                    <img class="md:h-8 h-6 object-contain" src="/icons/icons8_statistics_2@2x.png" alt="" srcset="">
                                    <p class="text-white hidden xl:block text-lg">{{ $t('messtatistiques') }}</p>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="h-full w-full xl:w-[82%] overflow-hidden">
                        <router-view name="three"></router-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { CircleProgressBar } from 'vue3-m-circle-progress-bar';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

export default {
    components: { CircleProgressBar, VueDatePicker  },
    data(){
        return{
            user:this.$store.state.dataAccueil[0],
            etape:1,
            saveLoading:'',
            langue:'',
            form:{
                sexe:'Homme',
                ville:'',
                description:'',
                date_naissance:'',
                avatar:'',
                quartier:'',
                mon_pays:'Cameroun'
            },
            villes:[],
            error:'',
            avatarSelect:'',
            flow:['year', 'month', 'calendar'],
        }
    },
    watch: {
      requestAccueil: {
        handler(newValue) {
          this.user = newValue[0]
        },
        deep: true
      },
    },
    mounted(){
        this.requestAuth == 'NotAuth' ? this.$router.push('/'):''
        if(!localStorage.getItem('jwtToken')){
            this.$router.push('/');
        }
        var parent = document.getElementById('previewpage')
        if(this.$store.state.preview){
            this.$store.state.preview.classList.remove('transition-next')
            parent.firstChild.className = 'preview-transition flex-shrink-0 w-full h-full flex'
            parent.firstChild.appendChild(this.$store.state.preview)
            document.querySelector(':root').style.setProperty('--tx', (document.getElementsByClassName('transition-next')[0].clientWidth) + 'px')
            document.querySelector(':root').style.setProperty('--ty', (document.getElementsByClassName('transition-next')[0].clientWidth * -1) + 'px')
        }else{
            parent.lastChild.classList.remove('transition-next')
        }
        this.$store.state.preview = parent.lastChild
        this.villes = this.$store.state.villes
        this.form.ville = this.villes.sort()[0]
        var date = new Date()
        this.form.date_naissance = `${date.getFullYear() - 18}-12-31` 
        this.langue = localStorage.getItem('langue')
    },
    methods:{
        handleDateUpdate(val) {
            if (!val) {
            this.form.date_naissance = null;
            return;
            }
            
            // Gestion des types (Date ou string)
            const dateObj = typeof val === 'string' ? new Date(val) : val;
            
            // Normalisation indépendante du fuseau
            const utcDate = new Date(Date.UTC(
            dateObj.getFullYear(),
            dateObj.getMonth(),
            dateObj.getDate()
            ));
            
            // Formatage sécurisé
            this.form.date_naissance = utcDate.toISOString().split('T')[0];
            
            // Alternative si problème avec toISOString()
            // this.form.date_naissance = [
            //   utcDate.getUTCFullYear(),
            //   String(utcDate.getUTCMonth() + 1).padStart(2, '0'),
            //   String(utcDate.getUTCDate()).padStart(2, '0')
            // ].join('-');
        },
        openAddProduct(){
            if(localStorage.getItem('jwtToken')){
            if(this.user.sexe && this.user.ville && this.user.description && this.user.date_naissance){
                this.$router.push('/ajouter_produit');
            }else{
                this.$router.push('/profil');
            }
            }else{
            this.$router.push('/login');
            }
        },
        addAvatar(image) {
            this.form.avatar = image.target.files[0]
            this.avatarSelect = URL.createObjectURL(image.target.files[0])
        },
        preview(){
            if(this.etape > 1){
                this.etape -= 1
            }
        },
        next(){
            if(this.etape < 3){
                if(this.etape == 1){
                    if(this.form.sexe && this.form.ville && this.form.quartier && this.form.description && this.form.date_naissance && this.form.mon_pays){
                        if(this.form.description.trim().length <= 600){
                            this.etape += 1
                            this.error = ''
                        }else{ 
                            window.emitter.emit("alertError", ['description long', this.$i18n.messages[`${localStorage.getItem('langue')}`].erreurdescriptionlongprofil])  
                        }
                    }else{
                        window.emitter.emit("alertError", ['etape 1', this.$i18n.messages[`${localStorage.getItem('langue')}`].veuillezremplirtousleschamps])
                    }
                }else{
                    this.etape += 1
                }
            }
        },
        saveInformation(){
            this.etape += 1 
            this.saveLoading = 'non'
            let user = new FormData();
            user.append('sexe', this.form.sexe);
            user.append('ville', this.form.ville);
            user.append('quartier', this.form.quartier);
            user.append('description', this.form.description);
            user.append('date_naissance', new Date(this.form.date_naissance).toLocaleDateString("en"));
            user.append('avatar', this.form.avatar);
            user.append('mon_pays', this.form.mon_pays);
            user.append('_method', 'PUT');
            this.axios.post(this.requestHttp + 'update_boutique', user,{
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
              },
            }).then(({data}) => {
                this.saveLoading = 'oui'
                this.$store.state.dataAccueil[0] = data 
                setTimeout(() => {
                  this.saveLoading = ''
                }, 3000);
                console.log(data)
            }).catch(
                error => {
                this.AddLoading = ''
                this.errors = error.response.data.message
            })
        },
        MaxYear(date) {
            var max = `${date.getFullYear() - 18}-12-31`
            return max;
        },
    },
    computed:{
        requestAuth() {
            return this.$store.state.auth
        },
      requestHttp(){
        return this.$store.state.api
      },
      requestAccueil(){
        return this.$store.state.dataAccueil
      },
      requestFile(){
        return this.$store.state.apifile
      },
    }
}
</script>

<style scoped>
    .link .router-link-active {
        background-color: rgb(180 109 2 / var(--tw-bg-opacity));
        color: #FF9900;
    }

    :root{
        --tx : 0;
        --ty : 0;
    }
    .transition-next{
        animation: transitLeft 3s;
        transform: translateX(var(--ty));
    }
      
    @keyframes transitLeft {
        0%{transform: translateX(0)}
        100%{transform: translateX(var(--ty))}
    }

    .preview-transition{
        animation: transitRight 3s;
        transform: translateX(var(--ty))
    }
      
    @keyframes transitRight {
        0%{transform: translateX(0)}
        100%{transform: translateX(var(--ty))}
    }
</style>